const createPolylineLayer = (id, sourceId, opts) => {
  opts = opts || {};
  return {
    id,
    type: 'line',
    source: sourceId,
    paint: {
      'line-color': opts['line-color'] ? opts['line-color'] : ['coalesce', ['get', 'color'], 'red'],
      'line-opacity': opts['line-opacity'] || 1,
      'line-width': opts['line-width'] || 5
    }
  };
};

export { createPolylineLayer };
